const CONTEXT_ID = "CONTEXT_ID_V2";

export function getContextIdFromStorage() {
  return localStorage.getItem(CONTEXT_ID) || "";
}

export function setContextIdToStorage(id: string) {
  localStorage.setItem(CONTEXT_ID, id);
}

export function removeContextIdFromStorage() {
  localStorage.removeItem(CONTEXT_ID);
}
